import type { MusicService } from '../types';
import { ImporterID } from '../ids';

/**
 * `id` intentionally matches the website id (`file-backup-excel-xlsx`) — the
 * fym-common legacy value `file-backup-excel-csv` is obsolete. `appId` maps
 * to the backend’s short identifier.
 */
export const fileBackup: MusicService = {
  id: 'file-backup-excel-xlsx',
  appId: 'file-backup',
  name: 'File Backup (Excel/XLSX)',
  shortName: 'File Backup',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#6417fb',
    label: '#6417FB',
    background: '#72678c',
  },
  importerID: ImporterID.File,
  assets: {
    logo: { light: 'file-light.svg', dark: 'file-dark.svg' },
    logoPadding: { light: 'file-light-padding.svg', dark: 'file-dark-padding.svg' },
    logoColor: { light: 'file-color-light.svg', dark: 'file-color-dark.svg' },
    logoColorPadding: {
      light: 'file-color-light-padding.svg',
      dark: 'file-color-dark-padding.svg',
    },
    logoOnBackground: 'file-color-dark.svg',
  },
};
